import React, { useState } from 'react';
import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import PropTypes from 'prop-types';
import { localize } from '../../util/Localizer';
import StyledLoading from '../Common/StyledLoading/StyledLoading';
import VideoContainer from './VideoContainer';

const FooterLabel = styled(Box)(() => ({
    fontFamily: 'MuseoSans500',
    fontSize: 14
}));

const FooterRow = styled('div')(() => ({
    display: 'flex',
    paddingTop: '8px'
}));

function CollapsableVideo({
    sortId,
    videoTitle,
    videoUrl,
    videoDescription,
    videoLength
}) {
    const [ loading, setLoading ] = useState(true);

    return(
        <Box>
            { loading
                ? (
                    <StyledLoading message={localize('resources.processing')} />
                ) : null
            }
            <Box alignItems="center"
                justifyContent="center">
                <VideoContainer
                    sortId={sortId}
                    videoUrl={videoUrl}
                    onLoad={() => setLoading(false)}
                />
                <FooterRow>
                    <FooterLabel sx={{ textAlign: 'left' }} data-testid={`videoTitle${sortId}`}>
                        {localize(videoTitle)}
                    </FooterLabel>
                    <FooterLabel sx={{ textAlign: 'left', ml: 'auto' }} data-testid={`videoLength${sortId}`}>
                        {videoLength}
                    </FooterLabel>
                </FooterRow>
                <FooterLabel sx={{ textAlign: 'left' }} data-testid={`videoDescription${sortId}`}>
                    {videoDescription}
                </FooterLabel>
            </Box>
        </Box>
    );
}

CollapsableVideo.defaultProps = {
    sortId: 0,
    videoTitle: '',
    videoUrl: null,
    videoDescription: '',
    videoLength: ''
};

/* eslint-disable react/forbid-prop-types */
CollapsableVideo.propTypes = {
    sortId: PropTypes.number,
    videoTitle: PropTypes.string,
    videoUrl: PropTypes.string,
    videoDescription: PropTypes.string,
    videoLength: PropTypes.string
};

/* eslint-enable react/forbid-prop-types */

export default CollapsableVideo;